import { createContext, PropsWithChildren, useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';

type CaseIdContextProps = {
  caseId?: string | null;
};

const DEFAULT_CASE_ID_CONTEXT: CaseIdContextProps = {
  caseId: null,
};

export const CaseIdContext = createContext<CaseIdContextProps>(DEFAULT_CASE_ID_CONTEXT);

export const CaseIdProvider = ({ caseId, children }: PropsWithChildren<CaseIdContextProps>) => {
  const { caseId: caseIdParam } = useParams<{ caseId: string }>();
  const value = useMemo(() => ({ caseId: caseId || caseIdParam }), [caseId, caseIdParam]);

  return <CaseIdContext.Provider value={value}>{children}</CaseIdContext.Provider>;
};

export const useCaseIdContext = () => {
  const context = useContext(CaseIdContext);
  if (!context) {
    throw new Error('useCaseIdContext must be used within an CaseIdContext');
  }
  return context;
};
